export const TRAIN_IC = "IC"
export const TRAIN_LYN = "LYN"
export const TRAIN_REG = "REG"
export const TRAIN_S = "S"
export const TRAIN_TOG = "TOG"
export const BUS = "BUS"
export const BUS_EXB = "EXB"
export const BUS_NB = "NB"
export const BUS_TB = "TB"
export const FERRY = "F"
export const METRO = "M"
